export interface SoldVehicle {
  id: number;
  name: string;
  make: string;
  model: string;
  year: number;
  price: number;
  soldPrice: number;
  mileage: number;
  bodyType: string;
  fuelType: string;
  transmission: string;
  drivetrain: string;
  exteriorColor: string;
  soldDate: string;
  daysOnLot: number;
  image: string;
  buyerCity: string;
}

// No sold vehicles yet — this will populate with real data as sales happen.
export const soldVehiclesMock: SoldVehicle[] = [];
